import { makeObservable, observable, action } from "mobx";
import { getUserDetail } from "../requests/user";

class UserProvider {
  detail: Nullable<UserDetailModel> = null;
  constructor() {
    makeObservable(this, {
      detail: observable,
      handleGteUserDetail: action,
    });
  }
  private async fetchUserDetail() {
    const res = await getUserDetail();
    if (res) {
      this.detail = res;
    }
  }
  public handleGteUserDetail() {
    this.fetchUserDetail();
  }
}

const userStore = new UserProvider();

export default userStore;
